module.exports = __webpack_public_path__ + "static/img/soldout.2a208fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/smallPicModel/soldout.svg
// module id = oEix
// module chunks = 1